var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{on:{"click":_vm.changeType}},[_vm._v("切换图表")]),_c('div',{staticStyle:{"height":"600px","width":"600px"},attrs:{"id":"myChart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }